import AntdAvatar from 'components/Avatar'

import Button from 'components/Button'
import FilterDiv from 'components/FilterDiv'
import objects from 'components/Images/OBJECTS.png'
import RoutePath from 'components/RoutePath'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import DeleteIcon from '../../components/icons/DeleteIcon'
import EditPenIcon from '../../components/icons/JobRoleIcons/EditPenIcon'
import Facebook from '../../components/icons/SocialMediaIcons/Facebook.svg'
import Instagramicon from '../../components/icons/SocialMediaIcons/Instagramicon.svg'
import Interneticon from '../../components/icons/SocialMediaIcons/Interneticon.svg'
import LinkedInIcon from '../../components/icons/SocialMediaIcons/LinkedInIcon.svg'
import TwitterIcon from '../../components/icons/SocialMediaIcons/TwitterIcon.svg'
import Youtubeicon from '../../components/icons/SocialMediaIcons/Youtubeicon.svg'
import { StyledTableSqare } from '../../components/TableStyles/TableStylesSqare/TableStylesSqare'
import {
  CompanyNameContainar,
  CorporateMasterDiv,
  NavigateSpan,
  TabCount,
} from '../Corporate/StyleComponents/style'
import { TopHeading } from '../Dashboard/Style/style'
import { SearchWidth, TableCount } from '../Events/EventRole/style'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from '../JobRoles/PageHeader/JobRoleFilter/style'
import {
  BoldText,
  CustomExportButton,
  LeftSection,
  MultiPadding,
  RightSection,
  SectionName,
} from '../JobRoles/PageHeader/style'
import { JobRoleFlex } from '../Placement/style'

import { Empty, Modal, Spin } from 'antd'
import Drawer from 'components/Drawer'
import NoInterview from 'components/icons/NoInterview.png'
import duplicate from 'components/Images/duplicate.png'
import Pagination from 'components/Pagination'
import MultiFilter from 'components/UIComponents/MultiFilter'
import {
  EmptyWrapper,
  SpanDescription,
} from 'modules/ATS/Components/IndividualTable/Style'
import {
  bulkUploadCorporate,
  deleteCoprorateDetails,
  getCorporateFilter,
  getCorporateList,
} from 'modules/Corporate/actions'
import {
  ButtonDiv,
  ModalTextCor,
  ModalTextCor1,
  ShortListModalImg,
} from 'modules/Events/Preview/Partials/PreviewBox/style'
import ErrorCorporateTable from 'modules/Students/Partials/StudentsBulkUpload/Partials/ErrorInfoTable/corporateError'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import { useDispatch, useSelector } from 'react-redux'
import { EmptyAnchor, EmptySpan } from '../../components/CommonStyles'
import ResultUploader from './Bulkupload/ResultUploader'
import ViewCorporate from './Bulkupload/ViewCorporate'
import SectorFilter from './SectorFilter/index'
import AddConfirm from './Upload'

export default function Corporate() {
  const [actionDrawer, setActionDrawer] = useState(false)
  const object = useRef()
  const navigate = useNavigate()
  const handleNewCorporateClick = () => {
    navigate('/corporate/newCorporate')
  }
  const dispatch = useDispatch()
  const instituteCampusId = useSelector(state => state.auth.instituteDetails.id)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [sectorFilter, setSectorFilter] = useState([])
  const [filterList, setFilterList] = useState([])
  const [filterMaster, setFilterMaster] = useState([])
  const [applyFilter, setApplyFilter] = useState([])
  const [viewCompanyDetails, setViewCompanyDetails] = useState(null)
  const [tableLoader, setTableLoader] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isModalVisibleDelete, setIsModalVisibleDelete] = useState(false)
  const [successDeleted, setSuccessDeleted] = useState(false)
  const [successDeletedFailed, setSuccessDeletedFailed] = useState(false)
  const { CORPORATE_API_URL } = process.env

  const menu = (
    <MenuFlex
      column
      className="job-roles-filter"
      style={{ width: 'max-content' }}
    >
      <StyledTab
        width={'35%'}
        padding={'20px'}
        border={true}
        tabPosition={'left'}
        type="card"
        items={[
          {
            label: ' Sectors',
            key: '1',
            children: (
              <SectorFilter
                sectorFilter={sectorFilter}
                setSectorFilter={setSectorFilter}
                filterList={filterList}
                setFilterList={setFilterList}
                filterMaster={filterMaster}
              />
              // <Role
              //   // options={roleFormFilterData}
              //   // value={
              //   //   roleFormFilterValue?.length !== 0 &&
              //   //   roleFormFilterValue?.map(item => {
              //   //     return item.value
              //   //   })
              //   // }
              //   // onChange={handleRoleChange}
              //   valueParam="value"
              //   labelParam="label"
              // />
            ),
          },
        ]}
      />

      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => handleFilterCancel()} />
        <Button.Primary
          text="Apply Filter"
          onClick={() => handleApplyFilter()}
        />
      </SubmitFlex>
    </MenuFlex>
  )
  const [file, setFile] = useState({})
  const [successFull, setSuccessFull] = useState(false)
  const [viewCorporate, setViewCorporate] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [pageNum, setPageNum] = useState(0)
  const [sortBy, setSortBy] = useState('')

  const [searchValue, setSearchValue] = useState('')
  const [showErrorTable, setShowErrorTable] = useState(false)
  const [errorData, setErrorData] = useState({})
  const [exportLoading, setExportLoading] = useState(false)

  const isNewCompany = createdAt => {
    const currentTime = new Date()
    const createdTime = new Date(createdAt)
    const timeDifference = currentTime - createdTime
    const twentyFourHoursInMillis = 24 * 60 * 60 * 1000
    return timeDifference <= twentyFourHoursInMillis
  }

  const onClickLink = link => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      link = 'https://' + link
    }

    // Open the link in a new tab
    const newTab = window.open('', '_blank')

    // Set the new tab's location to the link after a delay
    setTimeout(() => {
      newTab.location.href = link
    }, 100)
  }

  const handleApplyFilter = () => {
    setPageNum(0)
    setApplyFilter(sectorFilter)
    setIsMenuOpen(false)
  }
  const handleFilterCancel = () => {
    setIsMenuOpen(false)
  }

  const getSectorValues = (names, data) => {
    return names
      ?.map(name => {
        // Find the sector object that matches the name (case insensitive)
        const sector = data?.find(
          item => item?.label?.toLowerCase() === name?.toLowerCase()
        )
        return sector ? sector?.value : null
      })
      .filter(value => value !== null) // Remove null values in case of no match
  }
  const columns = [
    {
      title: 'Company Name',
      dataIndex: 'tittle',
      key: 'companyName',
      align: 'left',
      width: 353,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => {
        const firstLetter = data.companyName.charAt(0).toUpperCase()
        return (
          <CompanyNameContainar>
            <AntdAvatar
              size={40}
              style={{
                verticalAlign: 'middle',
              }}
              src={data?.logo?.url}
              IconName={data?.companyName?.split('')[0]}
              shape="square"
            ></AntdAvatar>
            <EmptyAnchor
              style={{
                color: 'rgba(50, 73, 215, 1)',
                fontWeight: '600',
                textTransform: 'capitalize',
              }}
              onClick={() => {
                setViewCompanyDetails(data)
                setViewCorporate(true)
              }}
            >
              {data?.companyName?.length > 25
                ? `${data?.companyName?.slice(0, 25)?.toLowerCase()}...`
                : data?.companyName?.toLowerCase()}
            </EmptyAnchor>
            {isNewCompany(data?.createdAt) && <TabCount>New</TabCount>}
          </CompanyNameContainar>
        )
      },
    },
    {
      title: 'Sector',
      dataIndex: 'company_name',
      key: 'sector',

      align: 'left',
      width: 227,
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => <>{data.sector}</>,
    },

    {
      title: 'POC-NAME',
      dataIndex: 'eligibleCandidates',
      key: 'eligibleCandidates',
      align: 'Left',
      width: 148,

      render: (text, data) => <>{data?.contactDetails?.[0]?.pocName}</>,

      sortDirections: ['ascend', 'descend'],
    },

    {
      title: 'POC NUMBER',
      align: 'left',
      width: 150,

      render: (text, data) => <>{data?.contactDetails?.[0]?.pocNumber}</>,
    },

    {
      title: 'SOCIALS',
      align: 'Left',
      width: 212,

      render: (text, data) => (
        <div style={{ marginRight: '10px' }}>
          {data?.website && (
            <NavigateSpan onClick={() => onClickLink(data?.website)}>
              <img
                src={Interneticon}
                alt="Internet Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}

          {data?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'facebook'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  data?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'facebook'
                  )?.link
                )
              }
            >
              <img
                src={Facebook} // Replace with your actual Facebook icon import or path
                alt="Facebook Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {data?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'instagram'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  data?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'instagram'
                  )?.link
                )
              }
            >
              <img
                src={Instagramicon} // Replace with your actual Instagram icon import or path
                alt="Instagram Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {data?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'linkedin'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  data?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'linkedin'
                  )?.link
                )
              }
            >
              <img
                src={LinkedInIcon} // Replace with your actual LinkedIn icon import or path
                alt="LinkedIn Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {data?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'youtube'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  data?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'youtube'
                  )?.link
                )
              }
            >
              <img
                src={Youtubeicon} // Replace with your actual YouTube icon import or path
                alt="YouTube Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {data?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'xlink'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  data?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'xlink'
                  )?.link
                )
              }
            >
              <img
                src={TwitterIcon} // Replace with your actual Twitter icon import or path
                alt="Twitter Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
        </div>
      ),
    },

    {
      title: ' ',
      render: (text, data) => (
        <div
          style={{
            display: 'flex',
            gap: '10px',
            cursor: 'pointer',
            marginLeft: '10px',
          }}
        >
          <EmptySpan
            style={{ paddingTop: '8px' }}
            onClick={() => {
              setViewCompanyDetails(data)
              setViewCorporate(true)
            }}
          >
            <EditPenIcon />
          </EmptySpan>
          <EmptySpan
            style={{ paddingTop: '5px' }}
            onClick={() => {
              setViewCompanyDetails(data)
              setViewCorporate(true)
            }}
          >
            <DeleteIcon />
          </EmptySpan>
        </div>
      ),
      align: 'center',
      width: 72,
      height: 60,
    },
  ]

  useEffect(() => {
    fetchCorporateList()
  }, [searchValue, pageNum, sortBy, applyFilter])

  useEffect(() => {
    fetchFilterList()
  }, [])

  const deleteCoprorate = async () => {
    let result = await dispatch(deleteCoprorateDetails(viewCompanyDetails?.id))

    if (result?.status >= 200 && result?.status <= 300) {
      setPageNum(0)
      fetchCorporateList()
      fetchFilterList()
      setIsModalVisible(false)
      setSuccessDeleted(true)
    } else {
      setIsModalVisible(false)
      setIsModalVisibleDelete(true)
    }
  }

  const openSuccess = () => {
    setIsModalVisibleDelete(false)
    setSuccessDeletedFailed(true)
  }
  const handleUpdate = async () => {
    let payload = {
      excelFileLink: file?.url,
    }
    let result = await dispatch(bulkUploadCorporate(payload))
    if (result?.status >= 200 && result?.status <= 300) {
      setFile({})
      fetchCorporateList()
      setSuccessFull(true)
    } else {
      setErrorData(result?.response?.data?.data?.failedRecords)
      setShowErrorTable(true)
    }
  }
  const CaptilizeLetter = text => {
    const words = text.toLowerCase().split('_')
    const camelCase = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
    return camelCase
  }
  const fetchFilterList = async () => {
    let result = await dispatch(getCorporateFilter())
    setFilterList(
      result?.uniqueSectors?.map(item => {
        return {
          label: CaptilizeLetter(item.sector),
          value: item.sectorId,
        }
      })
    )
    setFilterMaster(
      result?.uniqueSectors?.map(item => {
        return {
          label: CaptilizeLetter(item.sector),
          value: item.sectorId,
        }
      })
    )
  }
  const fetchCorporateList = async () => {
    const sectorValues = getSectorValues(applyFilter, filterMaster)
    setTableLoader(true)
    let result = await dispatch(
      getCorporateList(searchValue, pageNum, sortBy, sectorValues)
    )
    setCompanyList(result?.companymasterData)
    setTableLoader(false)
  }

  const handleMultiFilter = selectedValue => {
    setPageNum(0)
    setSectorFilter(selectedValue)
    setApplyFilter(selectedValue)
  }

  const handlePageChange = pagNum => {
    setPageNum(pagNum - 1)
    ScrollRef()
  }
  const handleSearch = e => {
    setPageNum(0)
    setSearchValue(e.target.value)
  }
  const handleSorting = (pagination, filter, sorter) => {
    setSortBy(sorter?.order ? sorter : '')
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
    setIsModalVisibleDelete(false)
  }

  const handleCloseModalDelete = () => {
    setSuccessDeleted(false)
    setSuccessDeletedFailed(false)
  }

  const handleExportClick = async () => {
    let uri =
      CORPORATE_API_URL +
      `corporate/institute/${instituteCampusId}/exporttoexcel`
    window.open(uri, '_blank')
  }
  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }
  const uploaderContent = () => {
    return (
      <>
        {successFull ? (
          <AddConfirm
            onClose={() => {
              setFile({})
              setActionDrawer(false)
              setSuccessFull(false)
            }}
            text={'Corporate successfully uploaded!'}
          />
        ) : (
          <>
            <ResultUploader
              openDrawer={actionDrawer}
              file={file}
              setFile={setFile}
              setShowErrorTable={setShowErrorTable}
            />
            {showErrorTable && file?.url && (
              <ErrorCorporateTable data={errorData} />
            )}
          </>
        )}
      </>
    )
  }

  const uploadFooter = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setFile({})
            setActionDrawer(false)
            setSuccessFull(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          form="bulkUpload"
          text="Update"
          disable={file?.length === 0}
          onClick={() => handleUpdate()}
        />
      </FooterFlex>
    )
  }
  return (
    <CorporateMasterDiv>
      <JobRoleFlex>
        <LeftSection centerVertically>
          <SectionName column>
            <RoutePath from="Corporate" path="/corporate" />
            <TopHeading> Listing</TopHeading>
          </SectionName>
        </LeftSection>
        <RightSection centerVertically>
          <CustomExportButton
            disabled={exportLoading}
            icon={
              exportLoading ? (
                <Spin
                  tip="Loading"
                  size="small"
                  style={{ display: 'flex', alignItems: 'center' }}
                />
              ) : (
                <></>
              )
            }
            text="Export"
            onClick={() => handleExportClick()}
          />

          <Button.Secondary
            height={'38px'}
            text={'Download / Upload'}
            onClick={() => setActionDrawer(true)}
          />
        </RightSection>
      </JobRoleFlex>

      <br></br>
      <RightSection centerVertically>
        <Button.Primary
          height={'38px'}
          text={'Add New Corporate'}
          onClick={() => handleNewCorporateClick()}
        />
      </RightSection>
      <br></br>
      <TableTop
        ref={object}
        centerVertically
        style={{ paddingTop: '0px' }}
        customHeight={'3rem'}
      >
        <SearchWidth>
          <SearchInput
            width={'80%'}
            placeholder={'Search By Keyword'}
            bordered={false}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearch={handleSearch}
          />
        </SearchWidth>
        <FilterDiv
          overlayMenu={menu}
          open={isMenuOpen}
          setOpen={setIsMenuOpen}
          onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
          width={'15%'}
        />

        <TableCount>
          {companyList?.count < 10
            ? `Showing ${companyList?.count}  of  ${companyList?.count}`
            : `Showing ${pageNum * 10 + companyList?.result?.length}  of ${
                companyList?.count
              }`}
        </TableCount>
      </TableTop>
      {applyFilter.length !== 0 && (
        <MultiPadding>
          <BoldText>Filter</BoldText>
          <MultiFilter
            jobRoleForm={applyFilter}
            option={false}
            handleChange={handleMultiFilter}
          />
        </MultiPadding>
      )}
      <StyledTableSqare
        columns={columns}
        dataSource={companyList?.result}
        pagination={false}
        bordered
        onChange={handleSorting}
        locale={{
          emptyText: (
            <EmptyWrapper column alignCenter>
              {tableLoader ? (
                <Spin />
              ) : (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 300 }}
                  description={
                    <SpanDescription>No data available</SpanDescription>
                  }
                />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      {companyList?.result?.length > 0 && (
        <Pagination
          onChange={handlePageChange}
          totalPages={companyList?.totalPage * 10}
          pageSize={10}
          current={pageNum + 1}
        />
      )}

      <Drawer
        width="40%"
        title={'Upload'}
        placement="right"
        closable={true}
        visible={actionDrawer}
        content={uploaderContent()}
        footer={!successFull ? uploadFooter() : null}
        onClose={() => {
          setFile({})
          setActionDrawer(false)
        }}
      />
      <ViewCorporate
        viewCorporate={viewCorporate}
        setViewCorporate={setViewCorporate}
        viewCompanyDetails={viewCompanyDetails}
        setViewCompanyDetails={setViewCompanyDetails}
        setIsModalVisible={setIsModalVisible}
      />

      {isModalVisible && (
        <Modal
          onClose={handleCloseModal}
          open={isModalVisible}
          footer={null}
          closable={false}
        >
          <ShortListModalImg>
            <img src={objects} alt="DeleteState" />
          </ShortListModalImg>
          <ModalTextCor>
            <span>Are you sure you want to </span>delete this corporate?
          </ModalTextCor>

          <ButtonDiv>
            <>
              <Button.Secondary
                height={'38px'}
                text={'No'}
                onClick={handleCloseModal}
              />
              <Button.Primary
                height={'38px'}
                text={'Yes'}
                onClick={deleteCoprorate}
              />
            </>
          </ButtonDiv>
        </Modal>
      )}

      {isModalVisibleDelete && (
        <Modal
          onClose={handleCloseModal}
          open={isModalVisibleDelete}
          footer={null}
          closable={false}
        >
          <ShortListModalImg>
            <img src={duplicate} alt="DuplicateState" />
          </ShortListModalImg>
          <ModalTextCor1>You can’t delete this corporate! </ModalTextCor1>
          <ModalTextCor1>
            Roles have been created with this corporate!{' '}
          </ModalTextCor1>
          <br></br>

          <ButtonDiv>
            <>
              <Button.Primary
                height={'38px'}
                text={'Okay'}
                onClick={openSuccess}
              />
            </>
          </ButtonDiv>
        </Modal>
      )}
      {successDeleted && (
        <Modal
          onClose={handleCloseModalDelete}
          open={successDeleted}
          footer={null}
          closable={false}
        >
          <AddConfirm
            onClose={() => {
              setSuccessDeleted(false)
              setSuccessDeletedFailed(false)
            }}
            text={'Corporate Deleted Successfully'}
          />
        </Modal>
      )}

      {successDeletedFailed && (
        <Modal
          onClose={handleCloseModalDelete}
          open={successDeletedFailed}
          footer={null}
          closable={false}
        >
          <AddConfirm
            onClose={() => {
              setSuccessDeleted(false)
              setSuccessDeletedFailed(false)
            }}
            text={'Corporate Not Deleted'}
          />
        </Modal>
      )}
    </CorporateMasterDiv>
  )
}
